<div class="alert" style="z-index: 999999999999999;">

    @switch(s_alert().type) {
        @case ('success') {
            <fa-icon [icon]="faSuccess" class="img"
                [class.success]="s_alert().type == 'success'"
                [class.error]="s_alert().type == 'error'"
                [class.warning]="s_alert().type == 'warning'"></fa-icon>
        }
        @case ('error') {
            <fa-icon [icon]="faError" class="img"
                [class.success]="s_alert().type == 'success'"
                [class.error]="s_alert().type == 'error'"
                [class.warning]="s_alert().type == 'warning'"></fa-icon>
        }
        @case ('warning') {
            <fa-icon [icon]="faWarning" class="img"
                [class.success]="s_alert().type == 'success'"
                [class.error]="s_alert().type == 'error'"
                [class.warning]="s_alert().type == 'warning'"></fa-icon>
        }
        @default {
            <fa-icon [icon]="faDefault" class="img info"></fa-icon>
        }
    }
    
    <h1 class="title">{{ s_alert().title }}</h1>
    
    <p class="sub" [innerHtml]="s_alert().msg"></p>
    <br/>
    
    <!-- <app-btn i_type="primary btn-dark" i_label="FECHAR" i_destiny="close-all" ></app-btn> -->
    <br/>
    <!-- @if (!x_loading) { --
        <br/>
        <div class="elegant-loader"></div>
    <!- }  -->
</div>